module.exports = "/assets/images/4272887e33cf10359dc4e5949db49377.svg";